import React from 'react';
import logo from '../../public/assets/logo/logo.png';

/** Inline car loader — drop inside any page-level loading state */
export const CarLoader: React.FC = () => (
  <div className="cl-panel">
    <img
      src={logo}
      alt="Loading"
      className="cl-steering"
      draggable={false}
    />
  </div>
);

/** Full-page loader (app bootstrap) */
const Loader: React.FC = () => (
  <div className="cl-fullscreen">
    <CarLoader />
  </div>
);

export default Loader;